import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import { DataCard } from '@/components/screens/HomePage/BloodSugarResponsePage/DataCard';
import { useGetPeekIntoData } from '@viome/viome-base/src/usecase/Home/HomeQuery';

export const DataCardsCarousel = ({ scoreId, 'data-testid': testId }: { scoreId: number; 'data-testid'?: string }) => {
  const { data: peekIntoData, isError: peekIntoDataError } =
    useGetPeekIntoData(scoreId);

  if (!peekIntoData || peekIntoDataError || peekIntoData.length === 0) {
    return null;
  }

  return (
    <div className="typography-h1 text-primary mt-8 select-none" data-testid={testId}>
      <div data-testid="dataCardsCarousel-title">A Peek into the data</div>
      <div className="mt-8" data-testid="dataCardsCarousel-container">
        <Carousel
          className="relative w-full"
          opts={{
            align: 'start',
            dragFree: true,
          }}
          data-testid="dataCardsCarousel-carousel"
        >
          <CarouselContent data-testid="dataCardsCarousel-content">
            {peekIntoData.map((card, index) => (
              <CarouselItem key={index} className="pl-4 basis-[22rem]" data-testid={`dataCardsCarousel-item-${index}`}>
                <DataCard
                  title={card.title}
                  subtitle={card.subtitle}
                  content={card.content}
                  footnote={card.footnote}
                  source={card.source}
                  link={card.link}
                  data-testid={`dataCardsCarousel-dataCard-${index}`}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden" data-testid="dataCardsCarousel-prev" />
          <CarouselNext className="hidden" data-testid="dataCardsCarousel-next" />
        </Carousel>
      </div>
    </div>
  );
};
